import { render, staticRenderFns } from "./SoalEdit.vue?vue&type=template&id=cf195b52&scoped=true"
import script from "./SoalEdit.vue?vue&type=script&lang=js"
export * from "./SoalEdit.vue?vue&type=script&lang=js"
import style0 from "./SoalEdit.vue?vue&type=style&index=0&id=cf195b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf195b52",
  null
  
)

export default component.exports